import { DateInput, NumberInput } from '@core/components/Inputs';
import CurrencyTextField from '@core/components/Inputs/CurrencyTextField';
import ReadOnlyInput from '@core/components/Inputs/ReadOnlyInput';
import { FormControl, Grid, InputLabel, MenuItem, Select, Tooltip } from '@material-ui/core';
import SelectTransportadora from 'app/components/Select/SelectTransportadora';
import React from 'react';

const getCurrency = (value) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);

const DadosEntrega = ({
  values,
  onChange,
  onBlur,
  calcularValorTotal,
  handleChangeTipoDesconto,
  styles,
  errors,
  touched,
  submitCount,
}) => {
  const valorTotalText = values?.valorTotal !== undefined ? getCurrency(values?.valorTotal) : '-';

  const _errors = {
    valorDesconto: (submitCount > 0 || touched?.valorDesconto) && errors?.valorDesconto,
    vendedor: (submitCount > 0 || touched?.vendedor) && errors?.vendedor,
  };

  const renderCampoFrete = () => {
    return (
      <CurrencyTextField
        id="valorFrete"
        name="valorFrete"
        value={values?.valorFrete}
        currencySymbol=""
        outputFormat="number"
        decimalCharacter=","
        digitGroupSeparator="."
        maximumValue="999999999"
        minimumValue="0"
        decimalPlaces={2}
        decimalPlacesShownOnBlur={2}
        decimalPlacesShownOnFocus={2}
        onChange={(e, value) => {
          const event = {
            target: {
              id: e.target.id,
              value: e.target.value === '' ? '' : value,
            },
          };
          onChange(event);
          calcularValorTotal(event);
        }}
        onBlur={onBlur}
        fullWidth
        variant="outlined"
        label="Frete a cobrar do cliente (R$)"
        disabled={
          !values?.habilitarFrete ||
          values?.possuiNotaFiscalTransmitida ||
          values?.possuiCobrancaRegistrada ||
          values?.origemIntegracao
        }
      />
    );
  };

  return (
    <>
      <Grid container spacing={3} className="mb-8">
        <Grid item xs={3}>
          {values?.habilitarFrete ? (
            renderCampoFrete()
          ) : (
            <Tooltip title="É possível informar o frete somente quando existe venda de produto." placement="top">
              <div>{renderCampoFrete()}</div>
            </Tooltip>
          )}
        </Grid>
        <Grid item xs={3}>
          <FormControl variant="outlined" style={{ width: '100%' }}>
            <InputLabel id="tipoDesconto">Tipo do desconto</InputLabel>
            <Select
              id="tipoDesconto"
              name="tipoDesconto"
              label="Tipo do desconto"
              labelId="tipo-desconto"
              value={values?.tipoDesconto}
              onChange={handleChangeTipoDesconto}
              onBlur={onBlur}
              disabled={
                !values?.habilitarTipoDesconto ||
                values?.possuiNotaFiscalTransmitida ||
                values?.possuiCobrancaRegistrada ||
                values?.origemIntegracao
              }
              displayEmpty
            >
              <MenuItem value=" ">
                <em>‎ </em>
              </MenuItem>
              <MenuItem value="PERCENTUAL">Percentual (%)</MenuItem>
              <MenuItem value="VALOR">Valor (R$)</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={3}>
          {values?.tipoDesconto === 'VALOR' ? (
            <CurrencyTextField
              id="valorDesconto"
              name="valorDesconto"
              value={values?.valorDesconto}
              currencySymbol=""
              outputFormat="number"
              decimalCharacter=","
              digitGroupSeparator="."
              maximumValue={values?.valorTotal}
              minimumValue="0"
              decimalPlaces={2}
              decimalPlacesShownOnBlur={2}
              decimalPlacesShownOnFocus={2}
              error={_errors.valorDesconto}
              helperText={_errors.valorDesconto}
              onChange={(e, value) => {
                const event = {
                  target: {
                    id: e.target.id,
                    value: e.target.value === '' ? '' : value,
                  },
                };
                onChange(event);
                calcularValorTotal(event);
              }}
              onBlur={onBlur}
              fullWidth
              variant="outlined"
              label="Desconto"
              disabled={
                !values?.tipoDesconto ||
                values?.possuiNotaFiscalTransmitida ||
                values?.possuiCobrancaRegistrada ||
                values?.origemIntegracao
              }
            />
          ) : (
            <NumberInput
              label="Desconto"
              id="valorDesconto"
              decimalScale={2}
              decimalSeparator=","
              allowNegative={false}
              isAllowed={(values) => {
                return !values.floatValue || values.floatValue <= 100;
              }}
              value={values?.valorDesconto}
              onChange={(e) => {
                onChange(e);
                calcularValorTotal(e);
              }}
              onBlur={onBlur}
              disabled={
                !values?.tipoDesconto ||
                values?.tipoDesconto === ' ' ||
                values?.possuiNotaFiscalTransmitida ||
                values?.possuiCobrancaRegistrada
              } // foi necessário colocar dessa forma por causa da documentação
              error={_errors.valorDesconto}
              touched={!!_errors.valorDesconto}
            />
          )}
        </Grid>
        <Grid item xs={3}>
          <ReadOnlyInput
            className={styles.valorTotal}
            id="valorTotal"
            label="Valor total (R$)"
            value={valorTotalText}
          />
        </Grid>
      </Grid>
      <Grid container spacing={3} className="mb-8">
        <Grid item xs={3}>
          <FormControl variant="outlined" style={{ width: '100%' }}>
            <InputLabel id="responsavelFrete">Responsável pelo frete</InputLabel>
            <Select
              id="responsavelFrete"
              name="responsavelFrete"
              label="Responsável pelo frete"
              labelId="responsavelFrete"
              value={values?.responsavelFrete}
              onChange={onChange}
              onBlur={onBlur}
              disabled={values?.origemIntegracao}
            >
              <MenuItem value=" ">
                <em>‎ </em>
              </MenuItem>
              <MenuItem value="EMITENTE">Por conta do emitente</MenuItem>
              <MenuItem value="DESTINATARIO_REMETENTE">Por conta do destinatário/remetente</MenuItem>
              <MenuItem value="TERCEIROS">Por conta de terceiros</MenuItem>
              <MenuItem value="SEM_FRETE">Sem frete</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={5}>
          <SelectTransportadora
            id="transportadora"
            fullWidth
            label="Transportadora"
            onChange={onChange}
            onBlur={onBlur}
            value={values?.transportadora}
            disabled={
              values?.possuiNotaFiscalTransmitida || values?.possuiCobrancaRegistrada || values?.origemIntegracao
            }
          />
        </Grid>

        <Grid item xs={2}>
          <DateInput
            id="previsaoEntrega"
            name="previsaoEntrega"
            label="Previsão de entrega"
            onChange={onChange}
            onBlur={onBlur}
            value={values?.previsaoEntrega}
            fullWidth
            variant="outlined"
            disabled={
              values?.possuiNotaFiscalTransmitida || values?.possuiCobrancaRegistrada || values?.origemIntegracao
            }
          />
        </Grid>
        {values?.situacao === 'EM_ORCAMENTO' && (
          <Grid item xs={2}>
            <DateInput
              id="dataVencimentoOrcamento"
              name="dataVencimentoOrcamento"
              label="Proposta válida até"
              onChange={onChange}
              onBlur={onBlur}
              value={values?.dataVencimentoOrcamento}
              fullWidth
              variant="outlined"
              disabled={
                values?.possuiNotaFiscalTransmitida || values?.possuiCobrancaRegistrada || values?.origemIntegracao
              }
            />
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default DadosEntrega;
